import React, {useRef, useEffect, useMemo, useState} from 'react';
import {Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label, FormRef} from "devextreme-react/form";
import Guid from "../../models/Guid";
import ITypePermis from "../../models/ITypePermis";
import {FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar} from '../base';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import {tr} from "date-fns/locale";

interface IGestionTypesPermisProps {
    isModeSelection?: boolean,
}

export default function GestionTypesPermis({isModeSelection}: IGestionTypesPermisProps) {
    const permisFormDataSource = useCustomDataSource<ITypePermis, ITypePermis>({path: "permisType", primaryKey: "idPermisType"});
    const {setMainForm, selectedDataRow: selectedTypePermis, setSelectedDataRow, mode, onFieldDataChanged, setMode, isFieldModifier, setIsFieldModifier} = permisFormDataSource;
    const formRef = useRef<FormRef>(null);
    const {editorOptions: typePermisEditorOption, PopupGestion: PopupGestionTypePermisPeche} = useLookUpBase({
        isModeModifier: mode !== Mode.Lecture,
        controllerName: "typepermispeche",
        setDataRow: () => setDataRow("idPermisType"),
        showClear: permisFormDataSource.mode !== Mode.Lecture,
        disabled: !selectedTypePermis.peche
    });

    const descriptionOptions = useMemo(() => {
        return {maxLength: 50}
    }, []);
    const actifOptions = useMemo(() => {
        return {text: "Actif"};
    }, []);
    const cerfVirginieOptions = useMemo(() => {
        return {text: "Cerfs de Virginie"};
    }, []);
    const certificatChasseurOptions = useMemo(() => {
        return {text: "Certificat de chasseur"};
    }, []);
    const orignalOptions = useMemo(() => {
        return {text: "Orignal"};
    }, []);
    const oursOptions = useMemo(() => {
        return {text: "Ours"};
    }, []);
    const petitGibierOptions = useMemo(() => {
        return {text: "Petits gibiers"};
    }, []);
    const pecheOptions = useMemo(() => {
        return {
            text: "Pêche",
            onFieldDataChanged: () => {
                // setSelectedDataRow((prev: ITypePermis) => {
                //   return { ...prev, peche: !prev.peche, typePermis: -1 }
                // })
            }
        };
    }, []);
    const permisConduireOptions = useMemo(() => {
        return {text: "Permis de conduire"};
    }, []);

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (mode !== Mode.Lecture)
            formRef.current?.instance().getEditor("description")?.focus();
    }, [mode])

    const setDataRow = (e: string) => {
        setSelectedDataRow((prev: ITypePermis) => (
            {...prev, [e]: Guid.empty.toString()}
        ));
        setIsFieldModifier(true);
    }

    const onSelectionchanged = (item: any, e: string) => {
        setIsFieldModifier(true);
        setSelectedDataRow((prev: ITypePermis) => {
            return {...prev, [e]: item.id}
        })
    }

    return (
        <FormListBase data={permisFormDataSource}>
            <FormListBaseGrid
                dataSource={permisFormDataSource.dataSource}
                onFocusedRowChanged={() => {
                    if (mode === Mode.Modifier) {
                        setMode(Mode.Lecture)
                    }
                }}>
                <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false}/>
            </FormListBaseGrid>
            <FormListBaseToolbar headerText={`${selectedTypePermis?.description || ''}`} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}}/>
            {!isModeSelection || isModeSelection && mode !== Mode.Lecture ? <FormListBaseTab>
                <TabItem title="Informations">
                    <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedTypePermis || {} as ITypePermis} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                        {/* <PopupGestionTypesPermis onSelectionchanged={(i) => onSelectionchanged(i, 'idpermistype')}>
              <PopupGestionTypePermisPeche isModeSelection={true} />
            </PopupGestionTypesPermis> */}
                        <SimpleItem key={"frm-description"} dataField={"description"}
                                    editorOptions={descriptionOptions}/>
                        <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                                    editorOptions={actifOptions}
                        >
                            <Label visible={false}/>
                        </SimpleItem>
                        <GroupItem caption={"Types de permis"}>
                            <SimpleItem key={"frm-cerf-virginie"} dataField={"cerfVirginie"} editorType={"dxCheckBox"}
                                        editorOptions={cerfVirginieOptions}>
                                <Label visible={false}/>
                            </SimpleItem>
                            <SimpleItem key={"frm-certificat-chasseur"} dataField={"certificationChasseur"} editorType={"dxCheckBox"}
                                        editorOptions={certificatChasseurOptions}>
                                <Label visible={false}/>
                            </SimpleItem>
                            <SimpleItem key={"frm-orignal"} dataField={"orignal"} editorType={"dxCheckBox"}
                                        editorOptions={orignalOptions}>
                                <Label visible={false}/>
                            </SimpleItem>
                            <SimpleItem key={"frm-ours"} dataField={"ours"} editorType={"dxCheckBox"}
                                        editorOptions={oursOptions}>
                                <Label visible={false}/>
                            </SimpleItem>
                            <SimpleItem key={"frm-petit-gibier"} dataField={"petitGibier"} editorType={"dxCheckBox"}
                                        editorOptions={petitGibierOptions}>
                                <Label visible={false}/>
                            </SimpleItem>
                            <GroupItem>
                                <SimpleItem key={"frm-peche"} dataField={"peche"}
                                            editorType={"dxCheckBox"}
                                            editorOptions={pecheOptions}>
                                    <Label visible={false}/>
                                </SimpleItem>
                                <SimpleItem
                                    key={"frm-type-permis"}
                                    dataField={"typePermis"}
                                    editorOptions={typePermisEditorOption}
                                    editorType={"dxSelectBox"}
                                >
                                    <Label text={"Type de permis de pêche"}/>
                                </SimpleItem>
                            </GroupItem>
                        </GroupItem>
                        <GroupItem caption={"Autres permis"}>
                            <SimpleItem key={"frm-permis-conduire"} dataField={"permisConduire"} editorType={"dxCheckBox"}
                                        editorOptions={permisConduireOptions}
                            >
                                <Label visible={false}/>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                </TabItem>
                <TabItem title="Système"><FormSysteme formData={selectedTypePermis || {} as ITypePermis}/></TabItem>
            </FormListBaseTab> : null}
        </FormListBase>
    );
}